var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-toast",class:'c-toast--' + _vm.toast.type,on:{"click":function($event){return _vm.close()}}},[_c('h5',[_vm._v(_vm._s(_vm.toast.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.toast.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }